import n from"styled-components";var o=n("div").withConfig({componentId:"sc-x0gfjw-0"})(["&:focus{outline:none;}padding:1rem;height:100%;width:100%;display:",";"],(function(n){return n.isActive?"block":"none"}));export{o as TabPanel};
